import connectingSound from './connecting.mp3';
import ringbackSound from './ringback.mp3';

export const CALL_CONNECTING_SOUND = connectingSound;
export const CALL_RINGBACK_SOUND = ringbackSound;
